import { Component, Vue } from 'vue-property-decorator'
import { Feature } from '~/plugins/feature-flags'

@Component
export default class ProviderStatisticsFeature extends Vue {
  getProviderStatisticsEnabled() {
    return this.$featureFlags?.isEnabled(Feature.ProviderStatistics)
  }
}
